import * as yup from "yup";
import constantes from "../../constantes";

const responsableRescateSchema = yup.mixed().when(
  "tipoServicio.nombre",
  {
    is: (nombre) =>
      (nombre ?? "").trim().toUpperCase() ===
      "MANTENIMIENTO RESCATE",

    then: yup
      .object()
      .shape({
        id: yup
          .number()
          .required("Seleccione quién atendió el rescate")
          .min(1, "Seleccione quién atendió el rescate"),
      })
      .nullable()
      .required("Seleccione quién atendió el rescate"),

    otherwise: yup.mixed().nullable(),
  },
);
const talleresExternosSchema = yup
  .array()
  .of(
    yup.object().shape({
      id: yup.number().required().min(1),
      nombreProveedorOtro: yup.string().nullable(),
    }),
  )
  .test(
    "nombre-proveedor-otros",
    "El nombre del proveedor es obligatorio",
    function (talleres) {
      if (this.parent.esExterno !== true) {
        return true;
      }

      const indexSinNombre = (talleres ?? []).findIndex(
        (taller) =>
          (taller?.nombre ?? "").trim().toUpperCase() === "OTROS" &&
          !taller?.nombreProveedorOtro?.trim(),
      );

      if (indexSinNombre === -1) {
        return true;
      }

      return this.createError({
        path: `tallerExterno[${indexSinNombre}].nombreProveedorOtro`,
        message:
          "El nombre del proveedor es obligatorio cuando selecciona OTROS",
      });
    },
  );

const guardar = yup.object().shape({
  nombreSolicitante: yup.string().required(),

  tipoServicio: yup.object({
    id: yup.number().required().min(1),
  }),

  mantenimiento: yup.mixed().when("tipoServicio.id", {
    is: constantes.tiposServicio.MantenimientoPreventivo,
    then: yup.mixed().required(),
  }),

  unidad: yup.object({
    id: yup.number().required().min(1),
  }),
responsableRescate: responsableRescateSchema,
  tallerExterno: talleresExternosSchema,
  fechaEntrada: yup.mixed().required(),
  fechaSalida: yup.mixed().required(),
  diagnosticoFinal: yup.mixed().required(),

  servicios: yup.array().of(
    yup.object().shape({
      actividadServicio: yup.mixed().when("existente", {
        is: true,
        then: yup.object().shape({
          id: yup.number().required().min(1),
        }),
      }),

      descripcion: yup.mixed().when("existente", {
        is: false,
        then: yup.string().required(),
      }),
    }),
  ),

  refacciones: yup.array().of(
    yup.object().shape({
      cantidad: yup.string().required(),

      unidadDeMedida: yup.mixed().when("existente", {
        is: false,
        then: yup.object().shape({
          id: yup.number().required().min(1),
        }),
      }),

      refaccion: yup.mixed().when("existente", {
        is: true,
        then: yup.object().shape({
          id: yup.number().required().min(1),
        }),
      }),

      nombre: yup.mixed().when("existente", {
        is: false,
        then: yup.string().required(),
      }),
    }),
  ),
});

const finalizar = yup.object().shape({
  nombreSolicitante: yup.string().required(),

  tipoServicio: yup.object({
    id: yup.number().required().min(1),
  }),

  mantenimiento: yup.mixed().when("tipoServicio.id", {
    is: constantes.tiposServicio.MantenimientoPreventivo,
    then: yup.mixed().required(),
  }),

  unidad: yup.object({
    id: yup.number().required().min(1),
  }),
  responsableRescate: responsableRescateSchema,
  tallerExterno: talleresExternosSchema,

  odometro: yup.string().required(),

  servicios: yup
    .array()
    .of(
      yup.object().shape({
        actividadServicio: yup.mixed().when("existente", {
          is: true,
          then: yup.object().shape({
            id: yup.number().required().min(1),
          }),
        }),

        descripcion: yup.mixed().when("existente", {
          is: false,
          then: yup.string().required(),
        }),
      }),
    )
    .test(
      "mecanico-requerido",
      "El mecánico es obligatorio",
      function (servicios) {
        if (this.parent.esExterno === true) {
          return true;
        }

        const indexSinMecanico = (servicios ?? []).findIndex(
          (servicio) => Number(servicio?.mecanicoId ?? 0) <= 0,
        );

        if (indexSinMecanico === -1) {
          return true;
        }

        return this.createError({
          path: `servicios[${indexSinMecanico}].mecanico`,
          message: "El mecánico es obligatorio",
        });
      },
    ),
  refacciones: yup.array().of(
    yup.object().shape({
      cantidad: yup.string().required(),

      unidadDeMedida: yup.mixed().when("existente", {
        is: false,
        then: yup.object().shape({
          id: yup.number().required().min(1),
        }),
      }),

      refaccion: yup.mixed().when("existente", {
        is: true,
        then: yup.object().shape({
          id: yup.number().required().min(1),
        }),
      }),

      nombre: yup.mixed().when("existente", {
        is: false,
        then: yup.string().required(),
      }),
    }),
  ),
});

const reprogramar = yup.object().shape({
  ComentariosReprogramacion: yup.string().required(),

  motivoReprogramacion: yup.object({
    id: yup.number().required().min(1),
  }),
});

const cancelacion = yup.object().shape({
  comentarios: yup.string().required(),
  fechaCancelacion: yup.string().required(),

  motivoCancelacion: yup.object({
    id: yup.number().required().min(1),
  }),
});

const ordenTrabajoValidacionEsquema = {
  guardar,
  finalizar,
  reprogramar,
  cancelacion,
};

export default ordenTrabajoValidacionEsquema;
